/** @format */

import { GatsbyBrowser } from 'gatsby';
import { App } from './src/App';

import './src/scss/style.scss';

export const wrapRootElement: GatsbyBrowser['wrapPageElement'] = App;
